// Single source of truth for loading the Cloudflare Turnstile API script.
//
// Two components touch Turnstile: Contact (implicit auto-render of a
// `.cf-turnstile` element) and FounderEmailReveal (explicit
// `window.turnstile.render(...)`). The explicit render API is available
// regardless of how the script is loaded, and we deliberately do NOT pass
// `?render=explicit` so Contact's auto-render keeps working. Loading the API
// more than once is unsupported by Cloudflare, so both callers go through this
// helper — one consistent URL and one prefix-matching dedup check — to
// guarantee the script is injected at most once per page.
const TURNSTILE_SRC =
  "https://challenges.cloudflare.com/turnstile/v0/api.js";

export function ensureTurnstileScript(): void {
  if (typeof document === "undefined") return; // no-op during SSG
  if (document.querySelector(`script[src^="${TURNSTILE_SRC}"]`)) return;
  const s = document.createElement("script");
  s.src = TURNSTILE_SRC;
  s.async = true;
  s.defer = true;
  document.head.appendChild(s);
}
